/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embedding_Error_Unsupported_SpreadsheetInputs */



/**
* | output |
* | --- |
* | "This spreadsheet format cannot be indexed. Save it as .xlsx or .csv and upload it again." |
*
* @param {Embedding_Error_Unsupported_SpreadsheetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const embedding_error_unsupported_spreadsheet = /** @type {((inputs?: Embedding_Error_Unsupported_SpreadsheetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embedding_Error_Unsupported_SpreadsheetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieses Tabellenformat kann nicht indexiert werden. Speichern Sie die Datei als .xlsx oder .csv und laden Sie sie erneut hoch.")
	return /** @type {LocalizedString} */ ("This spreadsheet format cannot be indexed. Save it as .xlsx or .csv and upload it again.")
});